import script from "./Total.vue?vue&type=script&setup=true&lang=js"
export * from "./Total.vue?vue&type=script&setup=true&lang=js"

import "./Total.vue?vue&type=style&index=0&id=3b8eec2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b8eec2e"]])

export default __exports__